interface IProps {
    color?: string;
};
export const TransferCirclrIcon = (props: IProps) => {
    const { color = "#BC9067" } = props;
    return (
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16.5" cy="16.7778" r="16" fill={color} />
            <path d="M9.0332 16.0278C8.61899 16.0278 8.2832 16.3636 8.2832 16.7778C8.2832 17.192 8.61899 17.5278 9.0332 17.5278L9.0332 16.0278ZM25.5635 17.3081C25.8564 17.0152 25.8564 16.5403 25.5635 16.2474L20.7906 11.4745C20.4977 11.1816 20.0228 11.1816 19.7299 11.4745C19.437 11.7674 19.437 12.2422 19.7299 12.5351L23.9725 16.7778L19.7299 21.0204C19.437 21.3133 19.437 21.7882 19.7299 22.0811C20.0228 22.374 20.4977 22.374 20.7906 22.0811L25.5635 17.3081ZM9.0332 17.5278L25.0332 17.5278L25.0332 16.0278L9.0332 16.0278L9.0332 17.5278Z"
                fill="white"
            />
        </svg>

    );
};
